// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { lycan as _lycan } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the lycan chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 721
 * Chain Name: Lycan
 * Default Block Explorer: https://explorer.lycanchain.com
 * Default RPC URL: https://rpc.lycanchain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { lycan } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: lycan,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const lycan = createCommon({
	..._lycan,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
